/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export const ProductsByTypeOptions = [
    {
        displayName: "Building Materials",
        value: "buildingMaterials",
    },
    {
        displayName: "Hearth Products",
        value: "hearthProducts",
    },
];

type ProductsByTypeState = {
    selectedProductsType: string;
};

const initialProductsByTypeState: ProductsByTypeState = {
    selectedProductsType: ProductsByTypeOptions[0].value,
};

const reducer = {
    "xProductsByType/SetSelectedProductsType": (
        draft: Draft<ProductsByTypeState>,
        action: { selectedProductsType: string },
    ) => {
        draft.selectedProductsType = action.selectedProductsType;
    },
};

const xProductsByType = createTypedReducerWithImmer(initialProductsByTypeState, reducer);

(reducers as any).xProductsByType = xProductsByType;

export type xProductsByTypeState = {
    xProductsByType: ProductsByTypeState;
};

type xProductsByTypeReducers = {
    ProductsByType: typeof xProductsByType;
};

export type xProductsByTypeActions = Parameters<xProductsByTypeReducers[keyof xProductsByTypeReducers]>[1] | AnyAction;
